import React, { useState, useEffect } from 'react';
import { Tooltip } from 'antd';
import  "./savingStatus.css";
import { useDocument } from '../../Pages/SpreadsheetContainer/documentInfoContex';

const SavingStatus = () => {
    const { savingData } = useDocument();
    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => {
            setIsSmallScreen(window.innerWidth < 768);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // Laid out as the Grid design's status line: a 6px dot (green once saved)
    // followed by 12px muted text. Same data as before; the icons became the dot.
    const dot = (color) => (
        <span className="SavedData-dot" style={{ background: color }} aria-hidden="true" />
    );
    const savedDetails = savingData?.lastSavedDateTime
        ? `${savingData.lastSavedDateTime}, ${savingData.fileSize}`
        : savingData?.fileSize;

    return (
        <div className={'SavedData-Conatiner'}>
            {savingData && (
                <>
                    {savingData.isSaving === 'Saving...' ? (
                        <Tooltip title="Saving your changes to Grid">
                            <span className="SavedData-text">
                                {dot('#e0a83a')}
                                <span className="SavedData-label">{savingData.isSaving}</span>
                            </span>
                        </Tooltip>
                    ) : savingData.isSaving === 'Saved' ? (
                        isSmallScreen ? (
                            // Phones: just the dot; the details live in the tooltip.
                            <Tooltip title={`Saved to Grid · ${savedDetails}`}>
                                <span className="SavedData-text" style={{ cursor: 'pointer' }} aria-label="Saved to Grid">
                                    {dot('#3aa76d')}
                                </span>
                            </Tooltip>
                        ) : (
                            // The details hide on narrow windows (see the CSS) but the
                            // tooltip always carries the full line.
                            <Tooltip title={`Saved to Grid · ${savedDetails}`}>
                                <span className="SavedData-text">
                                    {dot('#3aa76d')}
                                    <span className="SavedData-label">
                                        Saved to Grid<span className="SavedData-details"> &middot; {savedDetails}</span>
                                    </span>
                                </span>
                            </Tooltip>
                        )
                    ) : (
                        // Freshly loaded, nothing saved this session yet: the design's
                        // default line, with the file size when it is known.
                        <Tooltip title={`Saved to Grid · ${savingData.fileSize || 'Spreadsheet'}`}>
                            <span className="SavedData-text">
                                {dot('#3aa76d')}
                                <span className="SavedData-label">
                                    Saved to Grid<span className="SavedData-details"> &middot; {savingData.fileSize || 'Spreadsheet'}</span>
                                </span>
                            </span>
                        </Tooltip>
                    )}
                </>
            )}
        </div>
    );
};

export default SavingStatus;
